import styled from 'styled-components'

const Container = styled.div`
  position: absolute;
  flex-direction: column;
  bottom: 0;

  ${({ right }) => (right ? `right: 0;` : `left: 0;`)}
`

const ActionButtonContainer = ({ children, ...props }) => (
  <Container {...props}>{children}</Container>
)

export default ActionButtonContainer
